import api from '../baseApi.js'
import { byName, unwrap } from '../helpers.js'

export const galleryApi = {
  getAlbums: () => api.get('/gallery/albums').then(unwrap).then(byName),
  createAlbum: (data) => api.post('/gallery/albums', data).then(unwrap),
  updateAlbum: (id, data) => api.put(`/gallery/albums/${id}`, data).then(unwrap),
  deleteAlbum: (id) => api.delete(`/gallery/albums/${id}`).then(unwrap),
  getMedia: (albumId) => api.get(`/gallery/albums/${albumId}/media`).then(unwrap),
  uploadMedia: (albumId, formData) => api.post(`/gallery/albums/${albumId}/media`, formData).then(unwrap),
  deleteMedia: (mediaId) => api.delete(`/gallery/media/${mediaId}`).then(unwrap),
}
